__turbopack_context__.v({
  "donateFormModal": "styles-module__jUGQOW__donateFormModal",
  "donateFormModalContent": "styles-module__jUGQOW__donateFormModalContent",
  "donateFormModalInnerWide": "styles-module__jUGQOW__donateFormModalInnerWide",
  "donateFormModalWide": "styles-module__jUGQOW__donateFormModalWide",
  "donateFormTitle": "styles-module__jUGQOW__donateFormTitle",
});
